import React, { useContext } from 'react';
import { MobileContext } from '../wrappers/withMobile';
import DateFieldMobile from './DateFieldMobile';
import DateFieldDesktop from './DateFieldDesktop';


const DateField = (props) => {
  const { isMobile } = useContext(MobileContext);
  const Component = isMobile ? DateFieldMobile : DateFieldDesktop;
  return <Component {...props} />;
};

export default DateField;
